var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.88944068,5.56266898 L2.18162471,6.12686652 L2.09700904,6.1472495 C1.74747562,6.26445897 1.62511758,6.74288315 1.90259317,7.0260983 L4.5854453,9.76546172 L3.9525638,13.6325155 L3.94498464,13.7171586 C3.93930419,14.1046099 4.33834029,14.3780496 4.68307785,14.1882713 L8,12.3613663 L11.3169222,14.1882713 L11.3914583,14.2219752 C11.7416109,14.3473612 12.1132752,14.0344725 12.0474362,13.6325155 L11.4135478,9.76546172 L14.0974068,7.0260983 L14.1544206,6.95752897 C14.371405,6.64757412 14.2018371,6.18521205 13.8183753,6.12686652 L10.1095524,5.56266898 L8.45148251,2.04387616 C8.26680168,1.65204128 7.73319832,1.65204128 7.54851749,2.04387616 L5.88944068,5.56266898 Z M8,3.46865333 L9.32412194,6.2777889 L9.37596536,6.36513648 C9.45505215,6.4732101 9.57201682,6.5462249 9.70320586,6.56618594 L12.664175,7.01561639 L10.5215582,9.20348085 L10.4582441,9.28210181 C10.3845239,9.39425822 10.3543513,9.53330211 10.3767611,9.67011707 L10.8818801,12.756762 L8.23428675,11.300055 L8.14331305,11.2612978 C8.01866467,11.2225406 7.8830523,11.2354597 7.76571325,11.300055 L5.11711291,12.756762 L5.62323895,9.67011707 L5.63032824,9.56754287 C5.62701149,9.43143322 5.57337106,9.30037374 5.47844177,9.20348085 L3.33481806,7.01561639 L6.29679414,6.56618594 C6.46078045,6.54123465 6.60254115,6.43338684 6.67587806,6.2777889 L8,3.46865333 Z",
    id: "Star",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.9c405752920504ff5445c0c2b799a83e.svg";
export { ForwardRef as ReactComponent };